<template>
    <div>
        <div class="af-jobview-container afu-flex afu-flex-wrap">
            <div class="af-jobview-inner-container afu-flex afu-flex-wrap afu-w-full afu-max-w-screen-xl afu-ml-auto afu-mr-auto sm:afu-px-4 afu-items-start">
                <div class="af-jobview-content afu-w-full afu-px-0 md:afu-pr-16 md:afu-w-70p afu-box-border afu-py-0 md:afu-py-12">
                    <MqLayout mq="sm">
                        <JobViewContentMobile />
                    </MqLayout>

                    <MqLayout mq="tsm+">
                        <a
                            href="#"
                            class="afu-text-neutral-dark afu-text-lg md:afu-text-base afu-cursor-pointer afu-z-10 afu-relative"
                            @click="back"
                        >
                            <FontAwesomeIcon
                                :icon="['fas', 'chevron-left']"
                                size="xs"
                                class="afu-mr-2 afu-text-neutral-dark"
                            /> {{ $t('single_job.see_more_results') }}
                        </a>
                        <JobViewContent />
                    </MqLayout>
                </div>
                <MqLayout
                    class="af-jobview-sidebar afu-w-30p afu-box-border afu-py-12 afu-sticky afu-top-80"
                    mq="tsm+"
                >
                    <div>
                        <JobViewWidget />
                        <JobViewMap
                            v-if="isMapEnabled"
                            class="afu-mt-4"
                            :zoom="mapZoom"
                        />
                    </div>
                </MqLayout>
            </div>

            <MqLayout mq="sm">
                <ApplyJobMobile
                    :job-uuid="$_job.uuid"
                    :is-offsite-apply="$_job.is_offsite_apply"
                    :is-complete-apply="$_job.is_complete_apply"
                    :is-expired="$_job.is_expired"
                    :job-applied-at="$_job.applied_at"
                    :user-application-count="$_job.user_application_count"
                />
            </MqLayout>
        </div>
        <div
            v-if="showRelatedJobs !== 'hide'"
            class="af-jobview-container af-jobview-relatedJobs"
        >
            <JobViewMatchedJobs />
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import JobViewContent from './JobViewContent';
    import JobViewContentMobile from './JobViewContentMobile';
    import JobViewWidget from './JobViewWidget';
    import JobViewMap from './JobViewMap';
    import ApplyJobMobile from './Actions/ApplyJobMobile';
    import JobViewMatchedJobs from './JobViewMatchedJobs';
    import Cookie from '@/services/cookie';

    export default {
        name: 'JobViewTemplate',

        components: {
            JobViewContent,
            JobViewContentMobile,
            JobViewWidget,
            JobViewMap,
            ApplyJobMobile,
            JobViewMatchedJobs,
        },
        computed: {
            ...mapState({
                $_job: state => state.job.job,
            }),

            isMapEnabled() {
                return (
                    window?.afConfig?.job_details_map_enabled?.toLowerCase() ===
                    'yes'
                );
            },

            mapZoom() {
                let zoom = window?.afConfig?.job_details_map_zoom;

                if (zoom && typeof zoom === 'string') {
                    zoom = parseInt(zoom);
                }

                return zoom;
            },
        },
        props: {
            currentHost: {
                type: String,
                default: window.location.hostname,
            },
        },
        data() {
            return {
                lastHost: null,
                showRelatedJobs: window?.jobViewConfig?.relatedjobs || 'show',
            };
        },
        methods: {
            back() {
                // var oldURL = document.referrer;
                // var urlArr = oldURL.split('/');
                // var currUrl = window.location.href;
                // var currUrlArr = currUrl.split('/');

                // if (
                //     currUrlArr[2] == urlArr[2] &&
                //     oldURL.indexOf(this.$t('single_job.backToSearchUrl')) > -1 &&
                //     window.history.length > 1
                // ) {
                //     this.$router.go(-1);
                // } else {
                //     var jobsPageUrl = window?.afConfig?.base_url_search_result_page;
                //     if (!jobsPageUrl) {
                //         jobsPageUrl = this.$t('single_job.backToSearchUrl');
                //     }
                //     window.location.href =
                //         window.location.origin + '/' + jobsPageUrl;
                // }

                let url = Cookie.getJobFilter();
                let loc = Cookie.getWpmlLocale();
                let path = '/jobs' + (url ? url.replace('//', '/') : '');

                window.location.href = window.location.origin + (loc ? '/' + loc + path : path);
            },
        },
    };
</script>

<style lang="scss">
    @media print {
        body {
            margin: 0 !important;
            padding: 0 !important;
        }

        .af-app {
            .af-jobview-content-left {
                .af-jobview-content {
                    background-color: #fff;
                    font-size: 14px;
                    height: 100%;
                    left: 0;
                    line-height: 18px;
                    margin: 0;
                    padding: 0;
                    position: fixed;
                    top: 0;
                    width: 100%;
                    z-index: 9999;
                }

                .af-job-header {
                    padding: 0;
                }

                .af-job-consultants {
                    margin: 0;
                }

                .af-job-consultantsTitle {
                    margin: 0;
                }

                .af-job-features {
                    div {
                        break-inside: avoid;
                    }

                    span {
                        display: block;
                        break-inside: avoid;
                    }

                    a {
                        break-inside: avoid;
                    }
                }
            }
        }
    }
</style>
